var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchiveButtonPassive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5634_30987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6.64239L8 4.9709C8 3.80611 8 3.22371 8.34942 2.86186C8.69883 2.5 9.26121 2.5 10.386 2.5L13.614 2.5C14.7388 2.5 15.3012 2.5 15.6506 2.86186C16 3.22371 16 3.80611 16 4.9709V6.64239",
    stroke: "#56666C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.363 16.0512C18.2147 17.394 18.1087 18.3451 17.9516 19.0774C17.7974 19.796 17.6082 20.2278 17.3386 20.5574C17.1257 20.8178 16.8737 21.0435 16.5915 21.2265C16.2343 21.4583 15.7844 21.5989 15.0532 21.6733C14.308 21.7491 13.351 21.75 12.0001 21.75C10.6491 21.75 9.69209 21.7491 8.94691 21.6733C8.21571 21.5989 7.76583 21.4583 7.40858 21.2265C7.12643 21.0435 6.87441 20.8178 6.6615 20.5574C6.39192 20.2278 6.20271 19.796 6.04853 19.0774C5.8914 18.3451 5.78544 17.394 5.63713 16.0511L4.60216 6.68042L19.398 6.68042L18.363 16.0512Z",
    stroke: "#56666C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.62109H21",
    stroke: "#56666C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28708 16.4749C10.594 17.8417 12.7129 17.8417 14.0198 16.4749C15.3267 15.108 15.3267 12.892 14.0198 11.5251C12.7129 10.1583 10.594 10.1583 9.28708 11.5251M9 10.5V11.865C9 11.8843 9.01498 11.9 9.03347 11.9H10.3386",
    stroke: "#56666C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5634_30987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveButtonPassive);
export default __webpack_public_path__ + "static/media/unarchiveButtonPassive.8b4ec9e710d7dc3c3910f82840397be3.svg";
export { ForwardRef as ReactComponent };